import { useParams } from 'react-router-dom';
import { NavLink, useLocation } from 'react-router-dom';

import "./App.css";
import ShortContainer from "./components/ShortContainer";

function App() {
  const { page } = useParams();
  const location = useLocation();

  return (
    <div>
      <nav className="navbar">
        <div className="nav">
          <div className="logo-container">
            <NavLink to="/">
              <img src="https://www.m-arabi.com/images/banners/logo.png" className="logo" alt="" />
            </NavLink>
			</div>

          <div className="search-container">
            <input
              type="text"
              className="search"
              placeholder="Search pleces and videos"
            />
            <span></span>
            <button>
              <ion-icon name="search-outline"></ion-icon>
            </button>
          </div>

        </div>
      </nav>
      <main className="main">
        <aside>
          <ul className="user-nav">
            <li className={location.pathname === "/malaysia" ? "active" : ""}>
              <NavLink to="/malaysia">
                <ion-icon name="bookmarks-outline"></ion-icon>
                <span>Malaysia</span>
              </NavLink>
            </li>
            <li className={location.pathname === "/indonesia" ? "active" : ""}>
              <NavLink to="/indonesia">
                <ion-icon name="bookmarks-outline"></ion-icon>
                <span>Indonesia</span>
              </NavLink>
            </li>
            <li className={location.pathname === "/thailand" ? "active" : ""}>
              <NavLink to="/thailand">
                <ion-icon name="bookmarks-outline"></ion-icon>
                <span>Thailand</span>
              </NavLink>
            </li>
            <li className={location.pathname === "/singapore" ? "active" : ""}>
              <NavLink to="/singapore">
                <ion-icon name="bookmarks-outline"></ion-icon>
                <span>Singapore</span>
              </NavLink>
            </li>
          </ul>
          <ul className="nav-help">
            <li>
              <ion-icon name="pricetags-outline"></ion-icon>
              <span>#Best Hotels</span>
            </li>
            <li>
              <ion-icon name="pricetags-outline"></ion-icon>
              <span>#Best Places</span>
            </li>
            <li>
              <ion-icon name="pricetags-outline"></ion-icon>
              <span>#Best Tours</span>
            </li>
          </ul>

          <footer>
			  <NavLink to="/">
            <small>© 2024 Almohit</small>
			  </NavLink>
          </footer>
        </aside>
        <ShortContainer path={page} />
      </main>
    </div>
  );
}

export default App;